import { createSlice } from "@reduxjs/toolkit";
import { TrainingType , TrainerTypeState } from "./trainertypeType";
import { createTrainingType , updatetrainingtype , gettrainingtypeById ,fetchAlltrainingtype ,deletetrainingtypeById } from "./trainertypeAction";


const initialState : TrainerTypeState = {
    trainingtype : [],
    selectedtrainingtype : undefined,
    loading : false,
    error : undefined,
}

const trainingtypeSlice = createSlice({
    name : 'trainingtype',
    initialState,
    reducers : {},
    extraReducers : (builder) =>{
        builder
          .addCase(createTrainingType.pending,(state) =>{
            state.loading = true;
            state.error =undefined;
          })
          .addCase(createTrainingType.fulfilled, (state, action) => {
                            state.loading = false;
                            state.trainingtype.push(action.payload.data)
                          })
          .addCase(createTrainingType.rejected, (state, action) => {
                            state.loading = false;
                            state.error = action.payload as string;
                   })
        //update
                 .addCase(updatetrainingtype.pending,(state , action) =>{
                         state.loading=true ;
                         state.error = undefined;
                 })
                 .addCase(updatetrainingtype.fulfilled, (state, action) => {
                       state.loading = false;
                       const index = state.trainingtype.findIndex((d : any) => d.Id === action.payload.Id);
                       if (index !== -1) {
                           state.trainingtype[index] = action.payload;
                       }
                })
                 .addCase(updatetrainingtype.rejected, (state, action) => {
                  state.loading = false;
                  state.error = action.payload as string;
               })   
               
   //fetch all
          .addCase(fetchAlltrainingtype.pending,(state , action) =>{
           state.loading=true ;
           state.error = undefined;
         })
         .addCase(fetchAlltrainingtype.fulfilled, (state, action) => {
         state.loading = false;
         state.trainingtype=action.payload.data
         })
        .addCase(fetchAlltrainingtype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        })
   
        // Fetch  by ID
        .addCase(gettrainingtypeById.pending, (state) => {
          state.loading = true;
          state.error = undefined;
          })
          .addCase(gettrainingtypeById.fulfilled, (state, action) => {
              state.loading = false;
              state.trainingtype = action.payload;
          })
          .addCase(gettrainingtypeById.rejected, (state, action) => {
              state.loading = false;
              state.error = action.payload as string;
          })
   
   
          .addCase(deletetrainingtypeById.pending, (state) => {
               state.loading = true;
               state.error = undefined;
           })
           .addCase(deletetrainingtypeById.fulfilled, (state, action) => {
                state.loading = false;
                state.trainingtype = state.trainingtype.filter((d : any) => d.Id !== action.payload);
            })
            .addCase(deletetrainingtypeById.rejected, (state, action) => {
               state.loading = false;
               state.error= action.payload as string;
            })               
    }
})



export default trainingtypeSlice.reducer;